import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconRelatedContentStyle0 = gravityIconIndividualCss;

const GravityIconRelatedContent = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '6f3edbc068b3f351fa0e600ff6d7506a8bda7e60', color: this.color, size: this.size }, h("svg", { key: '7e84ea9ebed1c74cd7b3c899e1387c0f2bf6b0db', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'b29428cce1c49106cb348c9c27305032f699f4e0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.786 4.25a.288.288 0 0 0-.286.29v12.917c0 .16.128.29.286.29h9.679c.157 0 .285-.13.285-.29V14.25a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2H4V5.775h5.25V7.31a.5.5 0 0 0 .5.5h1.5v.941a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V7.505a.5.5 0 0 0-.143-.35l-2.71-2.756a.5.5 0 0 0-.356-.149H2.786ZM14.5 17.24a.5.5 0 0 0 .5.5h4.214c.158 0 .286-.13.286-.29V7.505a.5.5 0 0 0-.143-.35l-2.71-2.756a.5.5 0 0 0-.356-.149H13.5a.5.5 0 0 0-.5.5v.525a.5.5 0 0 0 .5.5H16V7.31a.5.5 0 0 0 .5.5H18v8.441h-3a.5.5 0 0 0-.5.5v.49ZM7.25 11a.25.25 0 0 1 .25-.25h8a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-8a.25.25 0 0 1-.25-.25v-1Z", fill: "currentColor" }))));
    }
};
GravityIconRelatedContent.style = GravityIconRelatedContentStyle0;

export { GravityIconRelatedContent as gravity_icon_related_content };

//# sourceMappingURL=gravity-icon-related-content.entry.js.map